@if (isAuthRoute()) {

  <!-- Authentication takes the whole viewport — no workflow chrome behind it. -->
  <main id="main-content" class="auth-screen" data-testid="auth-screen">
    <router-outlet />
  </main>

} @else {

  <!-- Skip navigation link — first focusable element in DOM (spec §11, AC-8) -->
  <a class="skip-nav" href="#main-content">Skip to main content</a>

  <!-- Sidebar — fixed, full viewport height, anchored to left edge -->
  <app-sidebar
    [collapsed]="false"
    [activeIndex]="activeStageIndex()"
    [completedIndices]="completedStageIndices()"
    [showWorkflow]="isWorkflowRoute()"
    (stageSelected)="onStageSelected($event)" />

  <!-- Content column — occupies all space to the right of the sidebar -->
  <div class="content-column" data-testid="app-shell">

    <!-- Toolbar — page title and profile icon, scoped to content column -->
    <app-toolbar [pageTitle]="pageTitle()" />

    <!-- Main content area — router outlet, fills remaining height -->
    <main id="main-content" class="main-content">

      <!-- Above the outlet, not inside each page: whether restored work is
           trustworthy is the same question on every stage. -->
      <app-session-notice [stageIndex]="activeStageIndex()" />

      <router-outlet />
    </main>

    <!-- Persistent Graphite footer -->
    <app-footer />

  </div>

}
